<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfLots="false"
              classFarms="`col-12 col-sm-12 col-md-4 col-lg-6 col-xl-6`"
            >
              <template slot="prev">
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                  :labelSelect="`${$t('common_words.status')}:`"
                  :dataOptions="status"
                  :initialSelection="dataFilter.status"
                  @onChange="handleChangeSelected"
                  modelName="status"
                />
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                  :labelSelect="`${$t('common_words.type')}:`"
                  :dataOptions="types"
                  :initialSelection="dataFilter.type"
                  @onChange="handleChangeSelected"
                  modelName="type"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card v-if="tableData.length > 0">
        <el-container>
          <aside-list
            addClass="col-text-ellipsis"
            @clickItem="loadData"
            :label="$t('common_words.indicators')"
            :list="indicators"
          />
          <el-container>
            <el-main>
              <div class="row">
                <div class="col-12">
                  <div v-if="tableData.length > 0">
                    <card
                      class="custom-shadow-card-header"
                      v-if="Object.keys(actualChart).length > 0"
                    >
                      <div class="row">
                        <chart-header-options
                          v-if="showChartOptions"
                          :autoChange="false"
                          :chartData="actualChart"
                          @handleLoadChartOptions="handleLoadChartOptions"
                        />
                        <div class="col-12">
                          <highcharts :options="actualChart"></highcharts>
                        </div>
                      </div>
                    </card>
                    <card
                      class="custom-shadow-card-header custom-table-responsive"
                    >
                      <div v-if="isIndex()">
                        <card-header
                          :propPagination="pagination"
                          @searchedQuery="searchedQuery"
                          class="mr-3 mt-4"
                        ></card-header>
                        <master-table
                          :infoTable="queriedData"
                          :columns="tableColumns"
                        >
                          <template slot="appendColumns">
                            <el-table-column
                              prop="status"
                              min-width="120"
                              :label="$t('common_words.status')"
                              :align="'center'"
                              :sortable="true"
                              :fixed="true"
                            >
                              <template slot-scope="scope">
                                <el-tag
                                  :type="getStatusTagType(scope.row.status)"
                                  >{{ scope.row.status }}</el-tag
                                >
                              </template>
                            </el-table-column>
                          </template>
                          <template slot="addColumnsOperations">
                            <table-columns-operations
                              v-if="isShow()"
                              @handleView="handleView"
                              :showOperationEdit="false"
                              :canDisable="true"
                              :canDelete="false"
                              :minWidth="100"
                            />
                          </template>
                        </master-table>
                      </div>
                      <not-index-permissions v-else />
                      <card-footer
                        :propPagination="pagination"
                        ref="cardfooter"
                      />
                      <export-tables
                        :pdf="{
                          filename: 'pqrs.pdf',
                          route: 'pqrs/pqrs/pdf',
                          paramMethod: 'POST',
                          plusData: { ...exportData, exportType: 'report' },
                        }"
                        :xls="{
                          filename: 'pqrs.xlsx',
                          route: 'pqrs/pqrs/excel',
                          paramMethod: 'POST',
                          plusData: { ...exportData, exportType: 'report' },
                        }"
                      />
                      <br />
                    </card>
                  </div>
                </div>
              </div>
            </el-main>
          </el-container>
        </el-container>
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="50%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <pqr-details-table :pqrData="rowData" />
          </div>
          <footer-date-at
            :createdAt="rowData.created_at"
            :updatedAt="rowData.updated_at"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import AsideList from 'src/components/Layouts/AsideList.vue';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import Filter from 'src/components/Filter/Filters.vue';
import MixinCharts from 'src/util/mixinCharts';
import MixinDinamicCharts from 'src/util/mixinDinamicCharts';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import configTable from './pqrReportTable';
import PqrTableDetails from '../PqrTableDetails.vue';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [AsideList.name]: AsideList,
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    [Filter.name]: Filter,
    [PqrTableDetails.name]: PqrTableDetails,
    highcharts: Chart,
  },

  computed: {
    ...configTable().Search,
    exportData() {
      const response = { ...this.dataFilter };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    indicators() {
      return [
        { id: 0, name: i18n.t('pqr.reception_methods') },
        { id: 1, name: i18n.t('pqr.type_by_process') },
        { id: 2, name: i18n.t('pqr.in_the_time_frame') },
        { id: 3, name: i18n.t('pqr.total_attended') },
      ];
    },
    status() {
      return this.concatAll([
        { id: 'abierto', name: i18n.t('pqr.open') },
        { id: 'en proceso', name: i18n.t('pqr.in_review') },
        { id: 'cerrado', name: i18n.t('pqr.closed') },
      ]);
    },
    types() {
      return this.concatAll([
        { id: 'peticion', name: i18n.t('pqr.petition') },
        { id: 'queja', name: i18n.t('pqr.complaint') },
        { id: 'reclamo', name: i18n.t('pqr.formal_claim') },
      ]);
    },
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
      showChartOptions: true,
      chartOptions: {},
      actualChart: {},
      dataFilter: {
        status: [],
        type: [],
      },
    };
  },

  mixins: [
    MixinCharts,
    MixinMasters,
    MixinDinamicCharts,
    MixinPermissions,
    MixinMenu,
    MixinForm,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.getData();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleView(_, row) {
      this.rowData = {
        ...row,
        created_at: moment(
          String(row.created_at),
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD hh:mm:ss'),
      };
      this.modals['read'] = true;
    },

    getStatusTagType(status) {
      switch (status) {
        case 'abierto':
          return 'primary';
        case 'en proceso':
          return 'warning';
        case 'cerrado':
          return 'info';
        default:
          return '';
      }
    },

    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      data.route = 'pqrs/reports';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data.pqrs;
          if (response.data.data.pqrs.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';

            try {
              this.chartOptions[0] = this.columns(
                response.data.data.firstIndicator
              );
              this.chartOptions[1] = this.columns(
                response.data.data.secondIndicator
              );
              this.chartOptions[2] = this.lines(
                response.data.data.thirdIndicator
              );
              this.chartOptions[3] = this.pieChart(
                response.data.data.fourthIndicator,
                null,
                true
              );
              this.actualChart = this.chartOptions[0];
              setTimeout(() => {
                const aside = document.getElementsByClassName(
                  'el-menu-item custom-el-menu-item-cal'
                )[0];
                aside.click();
              }, 0.1);
            } catch (error) {
              this.showMessageErrors(error);
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleLoadChartOptions(data) {
      this.$set(this.actualChart, data.index, data.chartData);
    },

    loadData(data) {
      this.showChartOptions = data.id === 3 ? false : true;
      this.actualChart = {};
      setTimeout(() => {
        this.actualChart = { ...this.chartOptions[data.id] };
      }, 0.1);
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    this.setupTable();
  },

  mounted() {
    this.selectedItemOnMenu('pqrs');
  },

  destroyed() {
    this.deselectedItemOnMenu('pqrs');
  },
};
</script>
